// import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './app/store';
import App from '@/App';
import './index.css';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

const Main = (
  <Provider store={store}>
    <BrowserRouter basename="/vite-react-ts-gh">
      <App />
    </BrowserRouter>
  </Provider>
);

export default Main;

root.render(Main);
